import React from 'react';
import { useParams } from 'react-router-dom';

import { Collapse, CollapseProps } from 'antd/es';

import LinkMore from '@app/components/UI/LinkMore/LinkMore';
import { Issues, Questions } from '@app/objects/Questions';
import '@app/scss/components/faqBlock.scss';

interface FaqBlockProps {
	questions: Array<Questions>;
	carrotIcon?: string | React.ReactNode;
	expandIconPosition?: 'right' | 'left';
	maxCount?: number;
	linkCategory?: string;
	category?: Issues;
	showCategory?: (category?: Issues) => void;
	visibleMore?: boolean;
}

const FaqBlock: React.FC<FaqBlockProps> = ({
	questions,
	carrotIcon,
	expandIconPosition = 'left',
	maxCount = 20,
	category,
	linkCategory,
	showCategory,
	visibleMore = false,
}) => {
	const params = useParams<{ id: string | undefined }>();

	const [items, setItems] = React.useState<CollapseProps['items']>([]);

	React.useEffect(() => {
		const questionsArray = questions.slice(0, maxCount);

		const items: CollapseProps['items'] = (!params.id ? questionsArray : questions).map((question: Questions, index: number) => {
			return {
				key: index,
				label: question.name,
				children: <p dangerouslySetInnerHTML={{ __html: question.text }} />,
			};
		});

		setItems(items);
	}, [questions]);

	return (
		<>
			<Collapse
				items={items}
				className="faq-block-body-questions"
				expandIcon={() => {
					return carrotIcon ? (
						typeof carrotIcon === 'string' ? (
							<img className="carrot-icon" src={carrotIcon} alt="arrow" />
						) : (
							carrotIcon
						)
					) : (
						<i className="fa fa-angle-down" aria-hidden="true" />
					);
				}}
				expandIconPosition={expandIconPosition}
			/>
			{questions.length > maxCount && !params.id && !visibleMore && (
				<div className="faq-block-body-questions-more btn-text">
					<LinkMore
						linkMoreHref={linkCategory || ''}
						linkMoreCaption="View more"
						handleCLick={() => showCategory && showCategory(category)}
					/>
				</div>
			)}
		</>
	);
};

export default FaqBlock;
